'use es6';

import { useDispatch } from 'react-redux';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { clearAddSectionMissingModuleErrors } from 'ContentEditorUI/redux/actions/appActions';
import { hydrateFailedCustomSectionTreeWithoutMissingModuleSchemas } from 'ContentEditorUI/redux/actions/moduleActions';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AddSectionModuleSchemaMissingErrorModal({
  missingModuleSchemaErrorCount
}) {
  const dispatch = useDispatch();
  const bodyMessageKey = missingModuleSchemaErrorCount > 1 ? 'plural' : 'single';
  const hydrateSectionCallback = () => {
    dispatch(hydrateFailedCustomSectionTreeWithoutMissingModuleSchemas());
    UsageTracker.trackEditorInteraction({
      action: 'Sections Action',
      event: 'added-section-with-missing-modules'
    });
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "danger",
    width: 525,
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "addSectionPanel.error.modal.title"
        })
      })
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `addSectionPanel.error.modal.body.${bodyMessageKey}`
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: hydrateSectionCallback,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "addSectionPanel.error.modal.confirm"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: () => dispatch(clearAddSectionMissingModuleErrors()),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "addSectionPanel.error.modal.reject"
        })
      })]
    })]
  });
}